'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInvalidFields;

var _getFormFields = require('./getFormFields');

var _getFormFields2 = _interopRequireDefault(_getFormFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getInvalidFields(form) {
  var formFields = (0, _getFormFields2.default)(form);

  return Object.keys(formFields).filter(function (key) {
    return !formFields[key].isValid;
  }).reduce(function (invalidFields, key) {
    invalidFields[key] = formFields[key];

    return invalidFields;
  }, {});
}
//# sourceMappingURL=getInvalidFormFields.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/helpers/getInvalidFormFields.js
// module id = 929
// module chunks = 5